import { render, staticRenderFns } from "./TheAPIDrawer.vue?vue&type=template&id=53932328&"
import script from "./TheAPIDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheAPIDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports